import { FormLabel } from "../FormLabel";
import { Timeline } from "../Timeline";

import * as theme from "./IconTimeline.css";
import { IconTimelineItem } from "./IconTimelineItem";
import { TimelineDotCircle } from "./TimelineDotCircle";

interface IconTimelineProps {
    items: IconTimelineItem[];
    label?: string;
}
export function IconTimeline({ items, label }: IconTimelineProps) {
    return (
        <div className={theme.root}>
            {label && <FormLabel>{label}</FormLabel>}
            <Timeline
                className={theme.timeline}
                items={items.map(toTimelineItem)}
            />
        </div>
    );
}

interface IconTimelineItem {
    date: string | undefined;
    label: string;
    icon: React.ReactNode;
    isPending?: boolean;
    isNotApplicable?: boolean;
}
function toTimelineItem({
    date,
    label,
    icon,
    isPending,
    isNotApplicable,
}: IconTimelineItem) {
    return {
        children: (
            <IconTimelineItem
                date={date}
                label={label}
                isPending={isPending}
                isNotApplicable={isNotApplicable}
            />
        ),
        dot: <TimelineDotCircle>{icon}</TimelineDotCircle>,
    };
}
